export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info',
  DARK = 'dark',
  LIGHT = 'light',
  LINK = 'link',
  UNSTYLED = 'unstyled',
  NO_VARIANT = 'noVariant'
}

export enum LoadingButtonVariant {
  LOADING_BUTTON = 'loadingButton',
  STANDARD = 'standard'
}
